import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOTable from "app/_L1_components/Elements/ReactOTable";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import ReactODropdown from "app/_L1_components/Elements/ReactODropdown";
import DateRangePicker from "react-bootstrap-daterangepicker";

import ReactOModal from "app/_L1_components/Elements/ReactOModal";
import ReactOTooltip from "app/_L1_components/Elements/ReactOTooltip";
import BandwidthOverlapChart from "app/components/Elements/BandwidthOverlapChart";

import { CustomInput } from "reactstrap";

/* Start Global Vars */
var c_o_w = "170px";
var c_o_h = "84px";
var graph1_width = "";
var graph1_height = "";
var c_width = "";
var b_left = "";
var c_height = "";
/* End Global Vars */

class Test extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      tick_height: "10px",
      mytime_start: "",
      mytime_end: "",
      timeoutMouse: "",
      time: { "One Hour": 3600, "Two Hours": 3600 * 2, "Half Hour": 1800 },
      time_range: "One Hour",
      spetro_success: 0,
      data: {},
      min: 0,
      max: 254,
      freq_forced: 0,
      freq_interval: "",
      has_data: false,
      c_high: false,
      c_low: false,
    };
    super(props, initState);

    this.mytime_end = "";
    this.mytime_start = "";
    this.freq_interval = "";
    this.freq_interval_first = "2402-2492";
    this.timeoutMouse = undefined;
    this.c_high = false;
    this.type_name = ["Average", "Peak"];
    this.c_low = false;
    this.has_data = false;
    this.freq_forced = 0;
    this.time_range = "One Hour";
    this.type = 0;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidUpdate() {}

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this._test_form.init();
    this.drawSpectro();
  }

  time_change(c_val, mytime_end, mytime_start) {
    this.c_high = this.c_low = this.has_data = 0;
    this.type = c_val;
    this.drawSpectro(
      c_val,
      Date.parse(mytime_end) / 1000,
      Date.parse(mytime_end) / 1000 - Date.parse(mytime_start) / 1000
    );
  }

  draw_all_ticks(dim_q, text_start, text_end, max_el, referenceFrequencyTicks, is_start) {
    return [...Array(max_el)].map((x, i) => {
      let _TMP = i == 0 ? 1 : i;
      let min = referenceFrequencyTicks[0];
      let max = referenceFrequencyTicks[2];
      let bg_color = "";
      let b_color = "#ced4da";
      let ml = _TMP * dim_q + "px";
      if (text_start + 5 * _TMP > max) ml = _TMP * dim_q - 1 + "px";
      let gw = dim_q + "px";
      let border = "";
      if (
        is_start == 1 &&
        text_start + 5 * (max_el - 1 - _TMP) <= max &&
        text_start + 5 * (max_el - 1 - _TMP) > min
      )
        b_color = bg_color = "#337ab7";
      else if (
        is_start != 1 &&
        text_start + 5 * _TMP <= max &&
        text_start + 5 * _TMP > min
      )
        b_color = bg_color = "#337ab7";
      else border = "1px solid " + b_color;
      let b_left = border;
      let b_top = "1px solid " + b_color;
      if (is_start == 1 && border == "") gw = parseInt(gw) + 1 + "px";
      //if((text_start+5*(_TMP)) == max)	b_left="";
      return (
        <div
          key={i}
          style={{
            borderLeft: b_left,
            borderTop: b_top,
            backgroundColor: bg_color,
            height: this.state.tick_height,
            position: "absolute",
            width: gw,
            marginLeft: ml,
          }}
        />
      );
    });
  }

  draw_tick(dim_q, text_start, text_end, max_el, referenceFrequencyTicks, is_start) {
    return is_start == 1 ? (
      <div
        style={{
          transform: "rotate(180deg)",
          position: "absolute",
          width: c_width,
          height: "40px",
          marginTop: "-40px",
        }}
        hidden={!this.has_data}
      >
        <div
          style={{
            display: "flex",
            width: dim_q - 1,
            position: "absolute",
            height: "36px",
            borderLeft: "1px solid #ced4da",
            borderTop: "1px solid #ced4da",
          }}
        >
          <span
            style={{
              transform: "rotate(180deg)",
              fontSize: "14px",
              marginBottom: "-6px",
              paddingRight: "4px",
              display: "inline-block",
              alignSelf: "flex-end",
            }}
          >
            {text_end}
          </span>
        </div>
        {(() => {
          return this.draw_all_ticks(
            dim_q,
            text_start,
            text_end,
            max_el,
            referenceFrequencyTicks,
            is_start
          );
        })()}
        <div
          style={{
            display: "flex",
            position: "absolute",
            marginLeft: b_left,
            borderRight: "1px solid #ced4da",
            height: "36px",
          }}
        >
          <span
            style={{
              transform: "rotate(180deg)",
              fontSize: "14px",
              marginBottom: "-6px",
              paddingLeft: "4px",
              display: "inline-block",
              alignSelf: "flex-end",
            }}
          >
            {text_start}
          </span>
        </div>
      </div>
    ) : (
      <div className="d-flex justify-content-center">
        <div
          style={{
            position: "absolute",
            width: c_width,
            height: "40px",
            marginTop: "-16px",
          }}
          hidden={!this.has_data}
        >
          <div
            style={{
              display: "flex",
              width: dim_q - 1,
              position: "absolute",
              height: "36px",
              borderLeft: "1px solid #ced4da",
              borderTop: "1px solid #ced4da",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                marginBottom: "-6px",
                paddingLeft: "4px",
                display: "inline-block",
                alignSelf: "flex-end",
              }}
            >
              {text_start}
            </span>
          </div>
          {(() => {
            return this.draw_all_ticks(
              dim_q,
              text_start,
              text_end,
              max_el,
              referenceFrequencyTicks,
              is_start
            );
          })()}
          <div
            style={{
              display: "flex",
              position: "absolute",
              marginLeft: b_left,
              borderRight: "1px solid #ced4da",
              height: "36px",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                marginBottom: "-6px",
                paddingRight: "4px",
                display: "inline-block",
                alignSelf: "flex-end",
              }}
            >
              {text_end}
            </span>
          </div>
        </div>
      </div>
    );
  }

  drawSpectro(data, time, diff) {
    console.log("drawSpectro");
    console.log(this.props);
    console.log(data);
    console.log(time);
    console.log(diff);
    if (this._REFRESH_TOUT) {
      clearTimeout(this._REFRESH_TOUT);
    }
    graph1_height = 300;
    c_height = graph1_height + "px";

    let myfreq = this.props.freq;
    if (this.freq_forced != "0") myfreq = this.freq_forced;

    let myetime = this.props.etime;
    if (this.props.allfreq == 1) myetime = Math.round(new Date() / 1000);
    if (typeof time != "undefined") myetime = time;

    let mysectoget = this.props.sec_to_get;
    if (typeof diff != "undefined") mysectoget = diff;

    ////////////////////////////////
    this.mytime_end = this.getAppContext().momentjs(myetime, "X");
    this.mytime_start = this.getAppContext().momentjs(myetime - mysectoget, "X");
    ////////////////////////////////

    if (this.freq_interval == "") this.freq_interval = this.freq_interval_first;

    this.setState(
      {
        loading: true,
        spectro_success: 0,
      },
      () => {
        this.apiStore.fire("probe_spectro", {
          data: {
            probeuid: this.props.match.params.probeuid,
            freq: myfreq,
            stime: this.props.stime,
            etime: myetime,
            sectoget: mysectoget,
            peak: data,
          },
          ___onSuccess: (status, data) => {
            console.log("SPECTRO OK");
            this.setState(
              {
                loading: false,
                spectro_success: 1,
                spectro_data: data,
              },
              () => {}
            );
          },
          ___onEnd: () => {
            //	this._REFRESH_TOUT = setTimeout(() => {
            //		this.drawSpectro();
            //	}, 60000);
          },
        });
      }
    );
  }

  rect_clicked(e, thisel, matrix_freq, w, h, arr_timestamp, go_out, text_start) {
    return [
      parseInt(e.nativeEvent.offsetX / (w / matrix_freq[0].length)) + 1,
      parseInt(e.nativeEvent.offsetY / (h / matrix_freq.length)) + 1,
      e.pageX,
      e.pageY,
      matrix_freq[0].length,
      matrix_freq.length,
    ];
  }

  CanvasClick(e, thisel, matrix_freq, w, h, arr_timestamp, go_out, text_start) {
    if (this.props.allfreq != 1) return;
    let el = this.rect_clicked(
      e,
      thisel,
      matrix_freq,
      w,
      h,
      arr_timestamp,
      go_out,
      text_start
    );
    let n_rect_x = el[0];
    let n_rect_y = el[1];
    let y = el[5];

    var freq_interval =
      parseInt(text_start) +
      5 * (n_rect_x - 1) +
      "-" +
      (parseInt(text_start) + 5 * n_rect_x);
    let step =
      (parseInt(arr_timestamp[arr_timestamp.length - 1]) - parseInt(arr_timestamp[0])) /
      y;
    let start = parseInt(arr_timestamp[0]) + step * (n_rect_y - 1);
    this.apiStore.fire("overlaps", {
      data: {
        probeuid: this.props.match.params.probeuid,
        freq_start: parseInt(text_start) + 5 * (n_rect_x - 1),
        freq_end: parseInt(text_start) + 5 * n_rect_x,
        ts: start,
      },
      ___onSuccess: (status, data) => {
        console.log("OVERLAP OK");
        this._overlap_modal.open({
          ts: start,
          reference: data.overlapping,
          overlapping: data.overlapping,
          freq_interval: freq_interval,
        });
      },
    });
  }

  CanvasMouse(e, thisel, matrix_freq, w, h, arr_timestamp, go_out, text_start) {
    let el = this.rect_clicked(
      e,
      thisel,
      matrix_freq,
      w,
      h,
      arr_timestamp,
      go_out,
      text_start
    );
    let n_rect_x = el[0];
    let n_rect_y = el[1];
    let pos_abs_x = el[2];
    let pos_abs_y = el[3];
    let y = el[5];

    clearTimeout(this.timeoutMouse);
    document.getElementById("canvas_overlay").style.display = "none";

    if (go_out) return;

    this.timeoutMouse = setTimeout(function () {
      let value = matrix_freq[n_rect_y - 1][n_rect_x - 1];
      if (pos_abs_x + parseInt(c_o_w) > window.innerWidth)
        pos_abs_x = pos_abs_x - parseInt(c_o_w) - 16 - 8;
      if (pos_abs_y + parseInt(c_o_h) > window.innerHeight)
        pos_abs_y = pos_abs_y - parseInt(c_o_h) - 4;
      if (document.getElementById("canvas_overlay") == null) return;
      document.getElementById("canvas_overlay").style.left = pos_abs_x + 16 + "px";
      document.getElementById("canvas_overlay").style.top = pos_abs_y + "px";
      document.getElementById("canvasdbm").innerHTML = "-" + value;
      let step =
        (parseInt(arr_timestamp[arr_timestamp.length - 1]) - parseInt(arr_timestamp[0])) /
        y;
      let start = thisel
        .getAppContext()
        .momentjs(parseInt(arr_timestamp[0]) + step * (n_rect_y - 1), "X")
        .format("LTS");
      let end = thisel
        .getAppContext()
        .momentjs(parseInt(arr_timestamp[0]) + step * (n_rect_y - 1) + (step - 1), "X")
        .format("LTS");
      document.getElementById("canvastimestart").innerHTML =
        start + "&nbsp;&nbsp;3s<span style='font-size:14px'>&Delta;</span>";
      document.getElementById("canvastimeend").innerHTML = end;
      document.getElementById("canvasfreqstart").innerHTML =
        parseInt(text_start) +
        5 * (n_rect_x - 1) +
        "-" +
        (parseInt(text_start) + 5 * n_rect_x);
      document.getElementById("canvas_overlay").style.display = "";
    }, 500);
  }

  freqchange(freq, freq_interval) {
    this.c_high = this.c_low = this.has_data = 0;
    this.freq_interval = freq_interval;
    this.freq_forced = freq;
    this.drawSpectro(
      this.type,
      Date.parse(this.mytime_end) / 1000,
      Date.parse(this.mytime_end) / 1000 - Date.parse(this.mytime_start) / 1000
    );
  }

  timechange(start, end, range) {
    this.c_high = this.c_low = this.has_data = 0;
    this.time_range = range;
    this.drawSpectro(this.type, end, end - start);
  }

  onComponentWillUnmount() {}

  onRender() {
    var text_start = 2402;
    var text_end = 2492;
    var max_el = "";
    let myfreq = this.props.freq;
    if (this.freq_forced != "0") myfreq = this.freq_forced;

    let referenceBw = [{ bw_min: "", bw_carrier: "", bw_max: "" }];
    if (typeof this.props.data != "undefined") referenceBw = this.props.data.reference;

    let referenceFrequencyTicks = [
      referenceBw.bw_min,
      referenceBw.bw_carrier,
      referenceBw.bw_max,
    ];
    if (myfreq > 2500 && myfreq < 5400) {
      text_start = 5150;
      text_end = 5350;
    }
    if (myfreq > 5400 && myfreq < 5900) {
      text_start = 5470;
      text_end = 5875;
    }
    max_el = (text_end - text_start) / 5;
    var dim_q = graph1_width / max_el;
    return (
      <div>
        {this.props.allfreq == "1" ? (
          <Section
            designType="wide"
            className="mb-4 border-bottom border-3 border-gray300"
          >
            <div className="d-flex px-4 pt-4 pb-3">
              <div className="flex-grow-1 align-self-end">
                <h2>Spectrum graph</h2>
                <small className="text-muted"></small>
              </div>
            </div>
          </Section>
        ) : null}

        <Section designType="wide" className="mx-4 mb-4">
          <ReactOForm
            onSubmit={() => {}}
            onControllerReady={(form_controller) => {
              this._test_form = form_controller;
            }}
            onFormDataChange={() => {
              this.forceUpdate();
              let _input_high = this._test_form.getEntry("high");
              let _input_low = this._test_form.getEntry("low");
              this.setState(
                {
                  high: parseInt(isNaN(_input_high) ? this.state.high : _input_high),
                  low: parseInt(isNaN(_input_low) ? this.state.low : _input_low),
                },
                () => {
                  document.getElementById("_ID_slider_high").value = _input_high;
                  document.getElementById("_ID_slider_low").value = _input_low;
                }
              );
            }}
          >
            <Row>
              {/*<Col>
									<ReactOButton onClick={() => {
										//this.drawSpectro()
										this.c_high=this.c_low=this.has_data=0;
										this.drawSpectro()
									}}>
										Test
									</ReactOButton>
								</Col>*/}
              {this.props.allfreq == "1" ? (
                <Col xs={12} md={4} lg={2} className="text-left">
                  <label>FREQUENCY RANGE</label>
                  <ReactODropdown
                    color="primary"
                    size="md-2"
                    toggler={this.freq_interval}
                    default="2400"
                    options={[
                      {
                        name: <span className="text">{this.freq_interval_first}</span>,
                        active: this.freq_interval == this.freq_interval_first,
                        onClick: () => {
                          this.freqchange(2400, this.freq_interval_first);
                        },
                        render: () => {
                          return <div className="">{this.freq_interval_first}</div>;
                        },
                        value: "2400",
                      },
                      {
                        name: <span className="text">5150-5350</span>,
                        active: this.freq_interval == "5150-5350",
                        onClick: () => {
                          this.freqchange(5300, "5150-5350");
                        },
                        render: () => {
                          return <div className="">5150-5350</div>;
                        },
                        value: "5300",
                      },
                      {
                        name: <span className="text">5470-5875</span>,
                        active: this.freq_interval == "5470-5875",
                        onClick: () => {
                          this.freqchange(5800, "5470-5875");
                        },
                        render: () => {
                          return <div className="">5470-5875</div>;
                        },
                        value: "5800",
                      },
                    ]}
                  />
                </Col>
              ) : null}
              {this.props.allfreq == "1" ? (
                <Col xs={12} md={4} lg={2}>
                  <label>FROM DATE</label>
                  <br />
                  <DateRangePicker
                    initialSettings={{
                      containerClass: "w-100",
                      timePicker: true,
                      maxDate: this.getAppContext().momentjs(new Date() / 1000, "X"),
                      showCustomRangeLabel: false,
                      timePicker24Hour: true,
                      singleDatePicker: true,
                      timePickerSeconds: false,
                      startDate: this.mytime_end,
                      autoApply: false,
                    }}
                    onApply={(e, picker) => {
                      this.timechange(
                        picker.startDate.unix() - this.state.time[this.time_range],
                        picker.startDate.unix(),
                        this.time_range
                      );
                    }}
                  >
                    <button className=" nofocus btn btn-outline-secondary selected-date-range-btn w-100 text-left text-nowrap">
                      <span className="icon-calendar" style={{ marginRight: "8px" }} />
                      {this.getAppContext()
                        .momentjs(this.mytime_end, "X")
                        .format("LL")}{" "}
                      {this.getAppContext().momentjs(this.mytime_end, "X").format("LT")}
                    </button>
                  </DateRangePicker>
                </Col>
              ) : null}
              {this.props.allfreq == "1" ? (
                <Col xs={12} md={4} lg={2}>
                  <label>Hours</label>
                  <ReactODropdown
                    color="primary"
                    toggler={this.time_range}
                    default="3600"
                    options={[
                      {
                        name: <span className="text">Half Hour</span>,
                        active: this.time_range == "Half Hour",
                        onClick: () => {
                          this.timechange(
                            this.mytime_end / 1000 - 1800,
                            this.mytime_end / 1000,
                            "Half Hour"
                          );
                        },
                        render: () => {
                          return <div className="">Half Hour</div>;
                        },
                        value: "1800",
                      },
                      {
                        name: <span className="text">One Hour</span>,
                        active: this.time_range == "One Hour",
                        onClick: () => {
                          this.timechange(
                            this.mytime_end / 1000 - 3600,
                            this.mytime_end / 1000,
                            "One Hour"
                          );
                        },
                        render: () => {
                          return <div className="">One Hour</div>;
                        },
                        value: "3600",
                      },
                      {
                        name: <span className="text">Two Hours</span>,
                        active: this.time_range == "Two Hours",
                        onClick: () => {
                          this.timechange(
                            this.mytime_end / 1000 - 3600 * 2,
                            this.mytime_end / 1000,
                            "Two Hours"
                          );
                        },
                        render: () => {
                          return <div className="">Two Hours</div>;
                        },
                        value: "7200",
                      },
                    ]}
                  />
                </Col>
              ) : null}

              <Col xs={12} md={4} lg={this.props.allfreq == "1" ? 2 : 4}>
                <ReactOFormInput
                  type="text"
                  data_key="low"
                  prepend="-"
                  //	append={(
                  //		<div className="rounded-right" style={{
                  //			width: '38px',
                  //			height: '38px',
                  //			backgroundColor: 'rgba()' this.getAppContext().colors.success
                  //		}}/>
                  //	)}
                  label="Low (dBm)"
                  default={254}
                  validators={[
                    {
                      func: (value) => {
                        return !isNaN(value);
                      },
                      invalid_text: "Type a number",
                    },
                  ]}
                />
                <input
                  disabled={!this.has_data}
                  id="_ID_slider_low"
                  className={
                    "custom-range" + (this.props.allfreq == "1" ? " d-none" : "")
                  }
                  type="range"
                  min="1"
                  max="254"
                  onChange={(e) => {
                    this._test_form.handleFormChange("low", e.target.value);
                  }}
                />
              </Col>
              <Col xs={12} md={4} lg={this.props.allfreq == "1" ? 2 : 4}>
                <ReactOFormInput
                  type="text"
                  data_key="high"
                  prepend="-"
                  //	append={(
                  //		<div className="rounded-right" style={{
                  //			width: '38px',
                  //			height: '38px',
                  //			backgroundColor: this.getAppContext().colors.success
                  //		}}/>
                  //	)}
                  label="High (dBm)"
                  default={1}
                  validators={[
                    {
                      func: (value) => {
                        return !isNaN(value);
                      },
                      invalid_text: "Type a number",
                    },
                  ]}
                />
                <input
                  disabled={!this.has_data}
                  id="_ID_slider_high"
                  className={
                    "custom-range" + (this.props.allfreq == "1" ? " d-none" : "")
                  }
                  type="range"
                  min="1"
                  max="254"
                  onChange={(e) => {
                    this._test_form.handleFormChange("high", e.target.value);
                  }}
                />
              </Col>
              <Col xs={12} md={4} lg={this.props.allfreq == "1" ? 2 : 4}>
                <label>TYPE</label>
                <CustomInput
                  type="switch"
                  name="peak"
                  id="_ID_slider_peak"
                  className="d-none"
                  onChange={(e) => {
                    this.c_high = this.c_low = this.has_data = 0;
                    let c_val = document.getElementById("_ID_slider_peak").checked
                      ? 1
                      : 0;
                    this.drawSpectro(
                      c_val,
                      Date.parse(this.mytime_end) / 1000,
                      Date.parse(this.mytime_end) / 1000 -
                        Date.parse(this.mytime_start) / 1000
                    );
                  }}
                />
                <ReactODropdown
                  color="primary"
                  toggler={this.type_name[this.type]}
                  default="0"
                  options={[
                    {
                      name: <span className="text">Average</span>,
                      active: this.type == "0",
                      onClick: () => {
                        this.time_change(0, this.mytime_end, this.mytime_start);
                      },
                      render: () => {
                        return <div className="">Average</div>;
                      },
                      value: "0",
                    },
                    {
                      name: <span className="text">Peak</span>,
                      active: this.type == "1",
                      onClick: () => {
                        this.time_change(1, this.mytime_end, this.mytime_start);
                      },
                      render: () => {
                        return <div className="">Peak</div>;
                      },
                      value: "1",
                    },
                  ]}
                />
              </Col>
            </Row>
          </ReactOForm>

          <Panel
            className="mt-3 pb-4"
            rounded
            noBorder={this.props.allfreq == "1" ? false : true}
          >
            <_LoadingWrapper minHeight loadingPlug={this.state.loading}>
              <div>
                <div style={{ width: "100%" }} hidden={this.has_data}>
                  <div id="nospectro" style={{ display: "none" }}>
                    No Spectro Data
                  </div>
                </div>
                {this._test_form
                  ? (() => {
                      if (this.state.spectro_success == 1) {
                        let counter = 0;
                        let matrix_freq = [];
                        let arr_timestamp = [];
                        let WEB_GL = true;
                        let _C_low = 0;
                        let _C_high = 999999;
                        let data = JSON.parse(this.state.spectro_data);

                        Object.keys(data).forEach(function (key) {
                          arr_timestamp.push(key);
                          matrix_freq[counter++] = data[key].split(",");
                        });

                        if (this.props.allfreq == 1) {
                          graph1_width =
                            document.body.clientWidth -
                            document.getElementsByClassName("_layout-sidebar")[0]
                              .offsetWidth -
                            (this.getAppContext().media.isMobile ? 100 : 160);
                          if (
                            parseInt(
                              document.getElementsByClassName("_layout-sidebar")[0].style
                                .left
                            ) < 0
                          )
                            graph1_width =
                              document.body.clientWidth -
                              (this.getAppContext().media.isMobile ? 100 : 160);
                          graph1_height = matrix_freq.length;
                          c_height = graph1_height + "px";
                        } else
                          graph1_width =
                            document.getElementsByClassName("modal-content")[0]
                              .offsetWidth -
                            (this.getAppContext().media.isMobile ? 100 : 160);

                        if (typeof matrix_freq[0] != "undefined")
                          graph1_width =
                            parseInt(graph1_width / matrix_freq[0].length) *
                            matrix_freq[0].length;

                        c_width = graph1_width + "px";
                        b_left = graph1_width - 40 + 3.5 + "px";

                        document.getElementById("nospectro").style.display = "none";
                        if (matrix_freq.length == 0)
                          return (document.getElementById("nospectro").style.display =
                            "");
                        this.has_data = true;
                        matrix_freq.forEach((_C_row) => {
                          _C_row.forEach((_C_val) => {
                            if (parseInt(_C_val) > parseInt(_C_low)) {
                              _C_low = _C_val;
                            }
                            if (parseInt(_C_val) < parseInt(_C_high)) {
                              _C_high = _C_val;
                            }
                          });
                        });
                        if (!this.c_high) {
                          this._test_form.handleFormChange("high", _C_high);
                          document.getElementById("_ID_slider_high").value = _C_high;
                          this.c_high = true;
                          document
                            .getElementById("_ID_slider_high")
                            .setAttribute("min", _C_high);
                          document
                            .getElementById("_ID_slider_high")
                            .setAttribute("max", _C_low);
                          this._test_form.handleFormChange("low", _C_low);
                          document.getElementById("_ID_slider_low").value = _C_low;
                          this.c_low = true;
                          document
                            .getElementById("_ID_slider_low")
                            .setAttribute("min", _C_high);
                          document
                            .getElementById("_ID_slider_low")
                            .setAttribute("max", _C_low);
                        }

                        return (
                          <div className="mb-3">
                            <div className="mb-2 text-center mb-4">
                              <strong>
                                LOW: -{_C_low} dBm | HIGH: -{_C_high} dBm
                              </strong>
                            </div>
                            {WEB_GL ? (
                              <div className="d-flex justify-content-center h-100 w-100">
                                <span
                                  id="start_date"
                                  style={{
                                    marginTop: "-6px",
                                    paddingRight: "4px",
                                    fontSize: "14px",
                                    paddingLeft: "2px",
                                    position: "relative",
                                    display: "",
                                  }}
                                >
                                  {this.getAppContext()
                                    .momentjs(arr_timestamp[0], "X")
                                    .format("LT")}
                                </span>
                                <div
                                  style={{
                                    width: c_width,
                                    height: c_height,
                                    textAlign: "center",
                                    position: "absolute",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    this.CanvasClick(
                                      e,
                                      this,
                                      matrix_freq,
                                      graph1_width,
                                      graph1_height,
                                      arr_timestamp,
                                      0,
                                      text_start
                                    );
                                  }}
                                  onMouseMove={(e) => {
                                    this.CanvasMouse(
                                      e,
                                      this,
                                      matrix_freq,
                                      graph1_width,
                                      graph1_height,
                                      arr_timestamp,
                                      0,
                                      text_start
                                    );
                                  }}
                                  onMouseOut={(e) => {
                                    this.CanvasMouse(
                                      e,
                                      this,
                                      matrix_freq,
                                      graph1_width,
                                      graph1_height,
                                      arr_timestamp,
                                      1,
                                      text_start
                                    );
                                  }}
                                ></div>
                                <div
                                  className="text-left"
                                  id="canvas_overlay"
                                  style={{
                                    zIndex: "1000",
                                    border: "4px solid #337ab7",
                                    width: c_o_w,
                                    height: c_o_h,
                                    position: "fixed",
                                    borderRadius: "4px",
                                    backgroundColor: "#cecaca",
                                    display: "none",
                                  }}
                                >
                                  <div className="text-left">
                                    <span
                                      style={{
                                        paddingLeft: "8px",
                                        fontWeight: "bold",
                                        width: "54px",
                                        display: "inline-block",
                                      }}
                                    >
                                      Freq:
                                    </span>
                                    <span
                                      id="canvasfreqstart"
                                      style={{ paddingLeft: "0px" }}
                                    ></span>
                                  </div>
                                  <div className="text-left" style={{ display: "none" }}>
                                    <span
                                      style={{
                                        paddingLeft: "8px",
                                        fontWeight: "bold",
                                        width: "54px",
                                        display: "inline-block",
                                      }}
                                    >
                                      FreqEnd:
                                    </span>
                                    <span
                                      id="canvasfreqend"
                                      style={{ paddingLeft: "0px" }}
                                    ></span>
                                  </div>
                                  <div className="text-left">
                                    <span
                                      style={{
                                        paddingLeft: "8px",
                                        fontWeight: "bold",
                                        width: "54px",
                                        display: "inline-block",
                                      }}
                                    >
                                      Time:
                                    </span>
                                    <span
                                      id="canvastimestart"
                                      style={{ paddingLeft: "0px" }}
                                    ></span>
                                  </div>
                                  <div className="text-left" style={{ display: "none" }}>
                                    <span
                                      style={{
                                        paddingLeft: "8px",
                                        fontWeight: "bold",
                                        width: "54px",
                                        display: "inline-block",
                                      }}
                                    >
                                      TimeEnd:
                                    </span>
                                    <span
                                      id="canvastimeend"
                                      style={{ paddingLeft: "0px" }}
                                    ></span>
                                  </div>
                                  <div className="text-left">
                                    <span
                                      style={{
                                        paddingLeft: "8px",
                                        fontWeight: "bold",
                                        width: "54px",
                                        display: "inline-block",
                                      }}
                                    >
                                      dBm:
                                    </span>
                                    <span
                                      id="canvasdbm"
                                      style={{ paddingLeft: "0px" }}
                                    ></span>
                                  </div>
                                </div>
                                {(() => {
                                  return this.draw_tick(
                                    dim_q,
                                    text_start,
                                    text_end,
                                    max_el,
                                    referenceFrequencyTicks,
                                    1
                                  );
                                })()}
                                <canvas
                                  id="myCanvas"
                                  width={graph1_width}
                                  height={graph1_height}
                                  style={{ backgroundColor: "white" }}
                                />
                                {(() => {
                                  if (document.getElementById("myCanvas") != null) {
                                    var c = document.getElementById("myCanvas");
                                    var ctx = c.getContext("2d");
                                    ctx.clearRect(0, 0, graph1_width, graph1_height);
                                    let _coef_base = 1 / 60;
                                    let _peso_ext = 0.1;
                                    let _high_alpha =
                                      this.state.high * _coef_base * _peso_ext;
                                    let _low_alpha =
                                      1 - (90 - this.state.low) * _coef_base * _peso_ext;
                                    let _range_alpha = _low_alpha - _high_alpha;
                                    let _CT =
                                      (1 / (this.state.low - this.state.high)) *
                                      _range_alpha;
                                    matrix_freq.forEach((_C_row, _C_row_idx) => {
                                      let y =
                                        (graph1_height / matrix_freq.length) * _C_row_idx;
                                      let width = graph1_width / _C_row.length;
                                      let height = graph1_height / matrix_freq.length;
                                      _C_row.forEach((_C_cell, _C_cell_idx) => {
                                        let x =
                                          (graph1_width / _C_row.length) * _C_cell_idx;
                                        // let _TMP = _C_cell < this.state.high ? this.state.high : (_C_cell > this.state.low ? this.state.low : _C_cell);
                                        let alpha =
                                          _high_alpha + (_C_cell - this.state.high) * _CT;
                                        ctx.globalAlpha = alpha;
                                        ctx.fillRect(x, y, width, height);
                                      });
                                    });
                                  }
                                })()}
                                <span
                                  id="end_date"
                                  style={{
                                    marginTop: "-8px",
                                    paddingRight: "4px",
                                    fontSize: "14px",
                                    paddingLeft: "2px",
                                    position: "relative",
                                    height: "30px",
                                    display: "none",
                                  }}
                                >
                                  {this.getAppContext()
                                    .momentjs(
                                      arr_timestamp[arr_timestamp.length - 1],
                                      "X"
                                    )
                                    .format("LT")}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        );
                      }
                    })()
                  : null}
                {(() => {
                  if (
                    this.state.spectro_success == 1 &&
                    document.getElementById("end_date") != null
                  ) {
                    document.getElementById("end_date").style.top =
                      parseInt(c_height) - 8 + "px";
                    document.getElementById("end_date").style.left =
                      -(parseInt(c_width) + 40) + "px";
                    document.getElementById("end_date").style.display = "";
                  }
                })()}
                {(() => {
                  return this.draw_tick(
                    dim_q,
                    text_start,
                    text_end,
                    max_el,
                    referenceFrequencyTicks
                  );
                })()}
              </div>
            </_LoadingWrapper>
          </Panel>
        </Section>

        <ReactOModal
          modalId="overlap"
          size="lg"
          onControllerReady={(modal_context) => {
            this._overlap_modal = modal_context;
          }}
          header={(data) => {
            return (
              <div>
                Bandwidths overlap detail
                <small className="text-left d-flex align-items-center">
                  <div className="flex-shrink-1 mr-2">
                    <strong className="sub-title">AT DATETIME:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext().momentjs(data.ts, "X").format("L LT")}
                      </span>
                    </strong>
                  </div>
                </small>
              </div>
            );
          }}
          bodyClassName="p-0"
          body={(data) => {
            return data.reference ? (
              <div className="bg-light rounded-bottom">
                <Section
                  className="border-bottom border-2 border-gray300"
                  layoutManager="grid"
                  elementsPerRow={1}
                  gridSpacing={1}
                  gridSpacingColor={this.getAppContext().colors.gray300}
                >
                  <Section
                    layoutManager="grid"
                    elementsPerRow={1}
                    gridSpacing={1}
                    gridSpacingColor={this.getAppContext().colors.gray300}
                  >
                    <div className="d-flex flex-column p-3">
                      <div className="sub-title mb-2">
                        <strong>FREQUENCY RANGE</strong>
                      </div>
                      <h4 className="d-flex h-100 align-items-start">
                        {data.freq_interval} MHz
                      </h4>
                    </div>
                  </Section>
                  <div className="d-flexdisabled d-none flex-column p-3">
                    <div className="sub-title mb-2">
                      <strong>BANDWIDTHS OVERLAP GRAPH</strong>
                    </div>
                    {data.reference ? (
                      <BandwidthOverlapChart data={data} aspectRatio={3.8} />
                    ) : null}
                  </div>
                </Section>
                <div style={{ maxHeight: "400px" }} className="overflow-auto pb-3">
                  <ReactOTable
                    thClassName="px-3 py-1"
                    tdClassName="align-middle px-3 py-2"
                    thDividers
                    defaultSort={[
                      {
                        data_key: "rssi",
                        order: "desc",
                      },
                    ]}
                    cols={[
                      {
                        title: "BSSID",
                        data_key: "bssid",
                        width: "35",
                        sortable: true,
                      },
                      {
                        title: "CHANNEL FREQ",
                        align: "center",
                        data_key: "freq",
                        width: "15",
                        sortable: true,
                      },
                      {
                        title: "WIFI BEACON RSSI",
                        align: "center",
                        data_key: "rssi",
                        width: "20",
                        sortable: true,
                      },
                      {
                        title: "ESSID",
                        data_key: "essid",
                        width: "30",
                        sortable: true,
                      },
                    ]}
                    rows={(() => {
                      let _TMP = [];
                      [...data.overlapping].forEach((_C_network, _C_idx) => {
                        _TMP.push({
                          ...(_C_network.bssid == data.reference.bssid
                            ? { className: "table-primary" }
                            : {}),
                          index: _C_idx,
                          essid: {
                            value: _C_network.essid,
                            render: <span>{_C_network.essid}</span>,
                          },
                          freq: {
                            value: _C_network.bw_carrier,
                            render: (
                              <span>
                                <strong>{_C_network.bw_carrier} MHz</strong>
                              </span>
                            ),
                          },
                          rssi: {
                            value: _C_network.rssi,
                            render: (
                              <span>
                                <strong>{_C_network.rssi} dBm</strong>
                              </span>
                            ),
                          },
                          bssid: {
                            value: _C_network.bssid,
                            render: (
                              <span className="sub-title">
                                <span
                                  className={
                                    _C_network.bssid == data.reference.bssid
                                      ? "text-primary"
                                      : ""
                                  }
                                >
                                  <strong>{_C_network.bssid}</strong>
                                </span>
                                {_C_network.bssid_info ? (
                                  _C_network.bssid_info.ap_custom_data ? (
                                    (() => {
                                      let _tooltip_id = _C_network.bssid_info
                                        .ap_custom_data.mac_lan
                                        ? "_ap_cst_modal_" +
                                          _C_network.bssid.replace(/:/g, "") +
                                          "_" +
                                          _C_network.bssid_info.ap_custom_data.mac_lan.replace(
                                            /:/g,
                                            ""
                                          )
                                        : null;
                                      return (
                                        <div id={_tooltip_id}>
                                          {_C_network.bssid_info.ap_custom_data
                                            .mac_lan ? (
                                            <ReactOTooltip
                                              placement="bottom"
                                              target={_tooltip_id}
                                              text={
                                                "LAN mac address: " +
                                                _C_network.bssid_info.ap_custom_data
                                                  .mac_lan
                                              }
                                            />
                                          ) : null}
                                          {_C_network.bssid_info.ap_custom_data.name +
                                            (_C_network.bssid_info.ap_custom_data.ip == ""
                                              ? ""
                                              : " - " +
                                                _C_network.bssid_info.ap_custom_data.ip)}
                                        </div>
                                      );
                                    })()
                                  ) : (
                                    <div>{_C_network.bssid_info.long_desc}</div>
                                  )
                                ) : null}
                              </span>
                            ),
                          },
                        });
                      });
                      return _TMP;
                    })()}
                  />
                </div>
              </div>
            ) : null;
          }}
        />
      </div>
    );
  }
}

export default contextProvider(
  withRouter(Test),
  //	withDefinedContext(Test, 'Test', context_exposed_methods),
  {
    define: null,
  }
);
